/* eslint-disable camelcase */
import { PostSubmissionOffer, PostSubmissionOfferResponse } from '@/interfaces/pick-em';

const postSubmissionOfferAdapter = (
  postSubmissionOffer: PostSubmissionOfferResponse
): PostSubmissionOffer => {
  if (!postSubmissionOffer) {
    return null;
  }

  const {
    id,
    additional_fee,
    checksum,
    created_at,
    entry_slip_id,
    entry_slip_payout_if_accepted,
    expired_at,
    status,
    updated_at,
  } = postSubmissionOffer;

  return {
    id,
    additionalFee: additional_fee,
    checksum,
    createdAt: created_at,
    entrySlipId: entry_slip_id,
    entrySlipPayoutIfAccepted: entry_slip_payout_if_accepted,
    expiredAt: expired_at,
    status,
    updatedAt: updated_at,
  };
};

export default postSubmissionOfferAdapter;
